import type { AppVueRouter } from './types';
import { router } from './appRouter';
import getAppVueRouter from './getAppVueRouter';
import {
  createMerchantGuard,
  createPermissionGuard,
  createUserGuard,
} from './guards';

export default function createAppRouter(): AppVueRouter {
  const appRouter = getAppVueRouter(router);

  createUserGuard(router);
  createPermissionGuard(router);
  createMerchantGuard(router);

  return appRouter;
}
